export const API_ROUTES = {
  CARDS: {
    CARDHOLDERS: '/cards/cardholders',
    CARDHOLDER_ME: '/cards/cardholders/me',
    CREATE: '/cards',
    LIST: '/cards',
    BY_ID: (cardId: string) => `/cards/${cardId}`,
    DETAILS: (cardId: string) => `/cards/${cardId}/details`,
    STATUS: (cardId: string) => `/cards/${cardId}/status`,
    SPENDING_CONTROLS: (cardId: string) => `/cards/${cardId}/spending-controls`,
    TRANSACTIONS: (cardId: string) => `/cards/${cardId}/transactions`,
    BALANCE_ISSUING: '/cards/balance/issuing',
  },
} as const;
